import net from "../utils/net";

export const GetJobList = data => {
    return net.get("app/job/list", data);
  };

  export const DelJob = data => {
    return net.get("app/job/del", data);
  };

export const FilePre = data => {
  return net.post("print/job/pre", data);
};

export const UploadJobFile = data => {
  // return net.upload( data.baseUrl, "/server_convert/FileUpload", data.data);
  return net.upload( data.baseUrl, "/FileUpload", data.data);
};



export const GetUserJoibList = data => {
	return net.get('site/user/job', data)
}

export const GetJoibStatus = data => {
	return net.get('app/job/status', data)
}



export const GetJobPinCode = data => {
	return net.get('app/job/GetJobPinCode', data)
}
